import { types } from '../actions/appNotifications';

const initialState = {
  message: null,
  pending: false,
  notifications: null,
  isTimesheetRead: {
    enabled: false,
    status: null
  },
  isExpenseRead: {
    enabled: false,
    status: null
  }
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.SET_NOTIFICATION:
      return {
        ...state,
        message: action.payload
      };
    case types.REMOVE_NOTIFICATION:
      return {
        ...state,
        message: null
      };
    case types.GET_GLOBAL_NOTIFICATION_PENDING:
      return {
        ...state,
        pending: true
      };
    case types.GET_GLOBAL_NOTIFICATION_FULFILLED:
      return {
        ...state,
        pending: false,
        notifications: action.payload
      };
    case types.GET_GLOBAL_NOTIFICATION_REJECTED:
      return {
        ...state,
        pending: false
      };
    case types.UPDATE_NOTIFICATION_STATUS_FULFILLED:
      return {
        ...state,
        pending: false,
        notifications: {
          ...state.notifications,
          [action.payload.type]: state.notifications[action.payload.type].map((item) => {
            if (item.Id === action.payload.Id) {
              item.Read = true;
            }

            return item;
          })
        }
      };
    case types.SHOULD_UPDATE_TIMESHEETS_NOTIFICATION_READ:
      return {
        ...state,
        isTimesheetRead: {
          enabled: action.payload.enabled,
          status: action.payload.status
        }
      };
    case types.SHOULD_UPDATE_EXPENSES_NOTIFICATION_READ:
      return {
        ...state,
        isExpenseRead: {
          enabled: action.payload.enabled,
          status: action.payload.status
        }
      };
    case types.MARK_TIMESHEET_NOTIFICATIONS_READ_FULFILLED:
      return {
        ...state,
        isTimesheetRead: {
          enabled: false,
          status: null
        }
      };
    case types.MARK_EXPENSE_NOTIFICATIONS_READ_FULFILLED:
      return {
        ...state,
        isExpenseRead: {
          enabled: false,
          status: null
        }
      };
    default:
      return state;
  }
}
